module.exports = __webpack_public_path__ + "static/media/dashboard-analytics-large.8da81be2.png";